import type { AccountHistoryEvent } from '@/feature/terminal_tables/account_history/AccountEvent';
import { createHistoryStore } from '@/components/datagrid';

export const useAccountHistoryStore = createHistoryStore<AccountHistoryEvent, string>({
  devtoolsName: 'dex-account-history',
  getKey: (e: AccountHistoryEvent) => e.id.toString(),
  // Filter values may combine several event types, comma-separated (e.g. Transfers = "7,6").
  applyQuickFilter: (row, quick) => !!quick && quick.split(',').includes(row.eventType.toString()),
});
